import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Status, loadShowDetails } from "./show.slice";
import { RootState } from "../../store";
import { AppBar, Box, Grid, LinearProgress, Toolbar, Modal } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoIcon from '@mui/icons-material/Info';
import './show.css'
import Season from "./season.component";

const Show = () => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const {details, status} = useSelector((state: RootState) => state.showDetails);

    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const handleInfoModalOpen = () => setInfoModalOpen(true);
    const handleInfoModalClose = () => setInfoModalOpen(false);


    useEffect(() => {
        dispatch(loadShowDetails(id));
    }, [id, dispatch]);

    function handleGoBack() {
        navigate(-1);
    }

    return (
        <>
        <Box sx={{ flexGrow: 1 }}>
            <AppBar className="header">
                <Toolbar>
                    <div className="toolbar-back"><ArrowBackIcon onClick={handleGoBack} /></div>
                    <div className="toolbar-title"><h1>{details?.data?.title}</h1></div>
                    {status === Status.SUCCESSFUL && details?.data &&
                        <>
                            <div className="toolbar-info"><InfoIcon onClick={handleInfoModalOpen} /></div>
                            <Modal  open={infoModalOpen} onClose={handleInfoModalClose} onClick={handleInfoModalClose} >
                                <div className="modal">
                                    <div className="modal-last-update">Last Update: {details.data?.updated.split('T')[0]}</div>
                                    <div className="modal-courtesy-info">Information courtesy of<br />IMDb<br />(https://www.imdb.com).<br />Used with permission.</div>
                                </div>
                            </Modal>
                        </>
                    }
                </Toolbar>
            </AppBar>
        </Box>
        <Box component="main" sx={{ p: "70px 0 30px 0" }}>
            {status === Status.LOADING && <LinearProgress  />}
            {status === Status.SUCCESSFUL && !details?.data &&
                <Grid container spacing={2}>
                    <Grid item xs={12} className="error-message">Error retriving show information.</Grid>
                </Grid>
            }
            {status === Status.SUCCESSFUL && details?.data &&
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <div className="label-season">season</div>
                        <div className="table-wrapper">
                            <div className="flex-table" style={{width: `${details?.data?.seasons ? (Object.keys(details?.data?.seasons).length + 2) * 22 : 1}px`}}>
                                <div className="season-column">
                                    <div className="blank"></div>
                                    <div className="label-episode" style={{top: `${(((details?.data?.episodesPerSeason - 2) * 11) + 40)}px`}}>episode</div>
                                </div>
                                <div className="season-column">
                                    <div className="blank"></div>
                                    {[...Array(details?.data?.episodesPerSeason)].map((x,i) =>
                                        <div className="row-header">{i + 1}</div>
                                    )}
                                    <div className="avg-header">avg</div>
                                </div>
                                {details?.data?.seasons && Object.entries(details?.data?.seasons).map(([seasonNumber, seasonDetails]) => 
                                    <Season
                                        seasonNumber={parseInt(seasonNumber)}
                                        seasonDetails={seasonDetails}
                                        episodesPerSeason={details?.data?.episodesPerSeason}
                                        highestRating={details?.data?.highestRating}
                                        lowestRating={details?.data?.lowestRating}
                                    />
                                )}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            }
        </Box>
        </>
    );
}

export default Show;